import React from "react";
import clsx from "clsx";

import SkillLibraryService from "../../services/SkillLibraryService";
import AgentSourceIcon from "./AgentSourceIcon";

class AgentSkillTools extends React.PureComponent {
	renderTool = tool => {
		const { readFirstNames = [] } = this.props;
		const isReadFirst = readFirstNames.includes(tool.name);
		return (
			<span
				key={tool.name}
				className={clsx("tk-chip", !tool.isKnown && "tk-chip--gone")}
				title={tool.isKnown ? tool.name : "No longer in the tool catalogue"}
			>
				{tool.needs && <AgentSourceIcon icon={tool.needs} size="small" />}
				{tool.label}
				{isReadFirst && <span className="tk-chip__note">read first</span>}
			</span>
		);
	};

	render() {
		const { toolNames, catalogue, emptyText, mostShown, label } = this.props;
		const tools = SkillLibraryService.toolsNamed({ toolNames, catalogue });
		if (tools.length === 0) return emptyText ? <span className="tk-muted">{emptyText}</span> : null;
		const isCapped = mostShown && tools.length > mostShown;
		const shownTools = isCapped ? tools.slice(0, mostShown) : tools;
		const hiddenNames = isCapped ? tools.slice(mostShown).map(tool => tool.label) : [];

		return (
			<div className="tk-chips">
				{label && <span className="tk-chips__label">{label}</span>}
				{shownTools.map(this.renderTool)}
				{isCapped && (
					<span className="tk-chip tk-chip--muted" title={hiddenNames.join(", ")}>
						+{hiddenNames.length} more
					</span>
				)}
			</div>
		);
	}
}

export default AgentSkillTools;
